import {
	isEmpty,
	isNotEmpty
} from '../index.js'

const GAME_CODE = '__game_code__';
const DEFAULT_GAME_CODE = '';
const GAME_CODE_PATTERN = /^[a-z0-9][a-z0-9_-]{0,63}$/;

function normalizeGameCode(value) {
	const gameCode = String(value || '').trim().toLowerCase();
	if (!GAME_CODE_PATTERN.test(gameCode)) return '';
	return gameCode;
}

function gameCodeFromHostname(hostname) {
	const normalizedHostname = String(hostname || '').trim().toLowerCase();
	if (
		!normalizedHostname ||
		normalizedHostname === 'localhost' ||
		/^\d{1,3}(?:\.\d{1,3}){3}$/.test(normalizedHostname)
	) {
		return '';
	}

	const prefix = normalizedHostname.split('.')[0];
	if (!prefix || prefix === 'www') return '';
	return normalizeGameCode(prefix.split('-')[0]);
}
const ROLE_INFO = '__role_info__';
const LOGIN_DATA = '__login_data__';
const AUTO_POP_FLAG = '__auto_pop_flag__';

export default {
	getGameCode: function() {
		const hostnameGameCode = gameCodeFromHostname(window.location.hostname);
		const cachedGameCode = normalizeGameCode(localStorage.getItem(GAME_CODE));
		const gameCode = hostnameGameCode || cachedGameCode || DEFAULT_GAME_CODE;
		localStorage.setItem(GAME_CODE, gameCode);
		return gameCode;
	},
	setRoleInfo: function(roleInfo) {
		if (isNotEmpty(roleInfo)) {
			localStorage.setItem(ROLE_INFO, JSON.stringify(roleInfo))
		} else {
			throw 'RoleInfo is null!';
		}
	},
	getRoleInfo: function() {
		let roleInfo = localStorage.getItem(ROLE_INFO);
		if (isEmpty(roleInfo)) {
			return {};
		}
		return JSON.parse(roleInfo);
	},
	clearRoleInfo: function() {
		localStorage.removeItem(ROLE_INFO);
	},
	setLoginData: function(data) {
		localStorage.setItem(LOGIN_DATA, JSON.stringify(data))
	},
	getLoginData: function(data) {
		let loginData = localStorage.getItem(LOGIN_DATA);
		if (isEmpty(loginData)) {
			return {};
		}
		return JSON.parse(loginData);
	},
	setAutoPopFlag: function() {
		localStorage.setItem(AUTO_POP_FLAG, 1)
	},
	getAutoPopFlag: function() {
		return localStorage.getItem(AUTO_POP_FLAG)
	},
	clearAllCacheData: function() {
		localStorage.removeItem(LOGIN_DATA);
		localStorage.removeItem(ROLE_INFO);
		localStorage.removeItem(GAME_CODE);
		localStorage.removeItem(AUTO_POP_FLAG);
	}
}